import { Component, EventEmitter, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";

@Component({
  standalone: true,
  imports: [
    TranslateModule,
    LucideAngularModule,
  ],
  selector: "app-dialog-overlay",
  templateUrl: "./dialog-overlay.component.html",
})

export class DialogOverlayComponent {
  constructor() {}

  @Output() closed = new EventEmitter<boolean>();

  ignoreParentClick(e:Event) {
    e.stopPropagation()
  }
}
